'use strict';

var util = require('./property-util');

module.exports = {
    /**
     * Returns the keys of the provided map as a plain array
     */
    getKeys: function (map) {
        var keys = [];
        map.forEach(function (value, key, map) {
            keys.push(key);
        });
        return keys;
    },

    /**
     * Returns the keys of the provided map as a plain array except for the key with value 'keyNotIncluded'
     */
    getOtherKeys: function (map, keyNotIncluded) {
        var keys = [];

        map.forEach(function (value, key, map) {
            if (key != keyNotIncluded) {
                keys.push(key);
            }
        });

        return keys;
    },

    /**
     * Returns the values of the provided map as a plain array
     */
    getMapValueAsList: function (map) {
        var list = [];
        map.forEach(function (value, key, map) {
            list.push(value);
        });
        return list;
    },

    /**
     * Returns an array with only entries that contain the property-value pair
     *  (only works with primitive types - or with references to objects)
     */

    filterArray: function (array, propertyName, propertyValue) {

        if (util.isDefined(array) && util.isDefined(propertyName) && util.isDefined(propertyValue)) {
            var filteredArray = new Array();
            array.forEach(function (object) {
                if (object[propertyName] == propertyValue) {
                    filteredArray.push(object);
                }
            });
            return filteredArray;
        } else {
            return;
        }
    },

    /**
     * finds equal value,
     * if none is found it returns the value in front of the first value that is higher than the provided value
     *      if the dateSet is sorted, this will return the nearest lower value to the provided value
     *      when working with dates, the dataset should exist of 'getTime()' values aka integers
     */
    equalOrLower: function (dataSet, value) {
        // i should use a smart search method.
        if (angular.isDate(value)) {
            var compValue = value.getTime();
        } else {
            var compValue = value;
        }
        var found = undefined;

        if (module.exports.contains(dataSet, compValue)) {
            return compValue;
        }

        //as soon as 'some' returns true, loop breaks. perfect.
        dataSet.some(function (data) {
            if (data <= compValue) {
                found = data;
                return false;
            }
            if (data > compValue) {
                return true;
            }
        });

        return found;
    },

    /**
     * finds equal value
     *  if none is found it searches for a value that is higher than the specified value-parameter
     *  it then checks if the interval between the found value & the previous value is lower than the specified interval
     *  if so, return the found value, else return null
     *
     *
     *  @dataSet    array that should contain timestamps, should be sorted ASC
     *  @value      value to find, should be a date object or epoch time
     *  @interval   interval that will be checked for the lower requirement (in seconds)
     */
    equalOrLowerWithInterval: function (dataSet, value, interval) {
        // i should use a smart search method.
        if (angular.isDate(value)) {
            var compValue = value.getTime();
        } else {
            var compValue = value;
        }
        var found = undefined;

        if (module.exports.contains(dataSet, compValue)) {
            return compValue;
        }
        var returnedTrue = false;
        //as soon as 'some' returns true, loop breaks. perfect.
        dataSet.some(function (data) {
            if (data <= compValue) {
                found = data;
                return false;
            }
            if (data > compValue) {
                //if( data - compValue > (interval*1000)) {
                //    found = null;
                //}
                if (data - found > (interval * 1000)) {
                    found = null;
                }
                returnedTrue = true;
                return true;
            }
        });
        if (!returnedTrue) {
            found = null;
        }
        return found;
    },

    /**
     * Sort array by timestamp property
     * sorting function to be used by array.sort(###)
     */
    sortByTimestampASC: function (a, b) {
        var aTime = a.timestamp;
        var bTime = b.timestamp;
        return module.exports.sortDate(aTime, bTime);
    },

    sortDate: function (aTime, bTime) {
        aTime = aTime.getTime();
        if (aTime > bTime) {
            return 1;
        }
        if (aTime < bTime) {
            return -1;
        }
        // a must be equal to b
        return 0;
    },

    /**
     * Sort array by property (fieldname)
     * sorting function to be used by array.sort(###)
     */
    sortByPropertyASC: function (fieldName, a, b) {

        var aTime = a[fieldName];
        var bTime = b[fieldName];

        if (aTime > bTime) {
            return 1;
        }
        if (aTime < bTime) {
            return -1;
        }
        // a must be equal to b
        return 0;
    },


    sortNumericByPropertyName: function (fieldName, a, b) {

        if (!util.isDefined(a[fieldName])) {
            console.warn("Unable to sort on field name " + fieldName);
            return -1;
        }

        if (!util.isDefined(b[fieldName])) {
            console.warn("Unable to sort on field name " + fieldName);
            return 1;
        }

        var aTime = new Number(a[fieldName]);
        var bTime = new Number(b[fieldName]);


        if (aTime > bTime) {
            return 1;
        }
        if (aTime < bTime) {
            return -1;
        }
        // a must be equal to b
        return 0;
    },

    sortByOfficialId: function (array) {
        return array.sort(function (a, b) {
            return module.exports.sortNumericByPropertyName("officialId", a, b);
        });
    },

    removeFrom: function (array, object) {
        //remove it
        var index = array.indexOf(object);
        if (index > -1) {
            array.splice(index, 1);
        }
        return array;
    },

    contains: function (array, object) {
        return array.indexOf(object) !== -1;
    },

    get: function (array, object) {
        var index = array.indexOf(object);
        if (index > -1) {
            return array[index];
        }
        return undefined;
    },

    hasCheckedProperties: function (properties) {
        var hasSelectedProperties = false;
        if (angular.isDefined(properties)) {
            for (var x = 0; x < properties.length; x++) {
                var property = properties[x];
                if (angular.isDefined(property.checked)) {
                    if (property.checked) {
                        hasSelectedProperties = true;
                        break;
                    }
                }
            }
            return hasSelectedProperties;
        }
    },

    getLargest: function (array, fieldName) {
        var largest = 0;
        if (!angular.isDefined(array)) {
            return largest;
        }
        array.forEach(function (arrayEntry) {
            if (arrayEntry[fieldName] > largest) {
                largest = arrayEntry[fieldName];
            }
        });
        return largest;
    },

    getSmallest: function (array, fieldName) {
        var smallest;
        if (!angular.isDefined(array)) {
            return undefined;
        }
        array.forEach(function (arrayEntry) {
            if (!util.isDefined(smallest)) {
                smallest = arrayEntry[fieldName];
                return;
            } else if (arrayEntry[fieldName] < smallest) {
                smallest = arrayEntry[fieldName];
            }
        });
        return smallest;
    },

    isEmpty: function (property) {
        var empty = true;
        var checkLengthProperty = util.isDefined(property);
        if (checkLengthProperty) {
            if (angular.isDefined(property['length'])) {
                empty = property['length'] < 1;
            }
        }
        return empty;
    },

    isNotEmptyArray: function (array) {
        return !module.exports.isEmpty(array);
    },

    getFirstInList: function (array, propertyName, propertyValue) {
        var found = undefined;
        if (!util.isDefined(array)) {
            return found;
        }
        array.some(function (entry) {
            var value = entry[propertyName];
            if (util.isDefined(value)) {
                if (value == propertyValue) {
                    found = entry;
                    return true;
                }
            }
        });
        return found;
    },

    splitArrayInTwo: function (array) {
        var returnValue = [];
        if (array.length === 1) {
            returnValue.push(array);
            return returnValue;
        }

        var splitter = array.length / 2;
        for (var i = 0; i < array.length; i += splitter) {
            returnValue.push(array.slice(i, i + splitter));
        }
        return returnValue;
    },

    /**
     * Convert a valuefield to percentages (default 0-1 range)
     * @param collection
     * @param fieldname the fieldname that will be converted to percentages
     * @param multiplier (use this to change the range)
     */
    dataToPercentages: function (collection, fieldname, tofield, multiplier, digits) {
        var total = 0;
        collection.forEach(function (object) {
            if (util.isDefined(object[fieldname]) && angular.isNumber(object[fieldname]))
                total += object[fieldname];
        });
        if (total > 0) {
            collection.forEach(function (object) {
                object[tofield] = object[fieldname] / total;
                if (util.isDefined(multiplier)) {
                    object[tofield] *= multiplier;
                }
                if (util.isDefined(digits)) {
                    object[tofield] = Math.round(object[tofield] * Math.pow(10, digits)) / Math.pow(10, digits);
                }
            });
        }
        return total;
    },

    mergeGpsDataWithArray: function (gpsData, array) {
        var mapGpsData = new Map();
        var mapArray = new Map();
        var returnArray = [];

        gpsData.forEach(function (entry) {
            mapGpsData.set(entry.timestamp.getTime(), entry);
        });
        array.forEach(function (entry) {
            mapArray.set(entry.timestamp.getTime(), entry);
        });

        mapGpsData.forEach(function (value, key, map) {
            var entry = mapArray.get(key);
            var newObject = angular.extend({}, entry, value);
            returnArray.push(newObject);
        });

        return returnArray;
    },

    inList: function (list, value) {
        return list.indexOf(value) !== -1;
    },

    addUnique: function (list, newValue) {
        var set = new Set();
        list.forEach(function (v) {
            set.add(v);
        });
        set.add(newValue);
        return Array.from(set);
    },

    extractPropertyFromList: function (array, propertyName) {
        if (module.exports.isEmpty(array)) {
            return [];
        }
        var extracted = [];
        array.forEach(function (v) {
            extracted.push(v[propertyName]);
        });
        return extracted;
    }

};

